import { Property } from "../../models/Property";
import { A11yStandardType } from "../../models/A11yStandard";
import { PropertyPage } from "./PropertyPage";
import { MapContextProvider } from "../../contexts/mapContext";

export default function PropertyWrapper({
  property,
  a11yStandard,
  displayShops,
  companyIdAPIKey,
  fullscreen,
  buildingAreaId,
}: {
  property: Property;
  a11yStandard: A11yStandardType;
  displayShops: boolean;
  companyIdAPIKey: string;
  buildingAreaId: string | null;
  fullscreen: boolean;

}) {  

  return (
    <MapContextProvider>
      <PropertyPage
        property={property}
        a11yStandard={a11yStandard}
        displayShops={displayShops}
        companyIdAPIKey={companyIdAPIKey}
        buildingAreaId={buildingAreaId}
        fullscreen={fullscreen}
      />
    </MapContextProvider>
  );
}
